import React, { useRef, useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { safeNext, useAuth } from '../auth/AuthContext';
import { errorText } from '../errors';
import { authStyles as s } from './authStyles';

export default function Signup() {
  const { user, signup } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [invite, setInvite] = useState(params.get('invite') || '');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submitted = useRef(false);   // the submit handler navigates itself

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    submitted.current = true;
    const pw = password;
    setPassword('');   // the password does not outlive the submit
    try {
      await signup(email, pw, invite.trim());
      navigate('/settings', { replace: true });
    } catch (err) {
      setError(err.isAxiosError ? errorText(err, 'Could not create the account.') : err.message);
    } finally {
      submitted.current = false;
      setBusy(false);
    }
  };

  // Already signed in: nothing to do here.
  if (user && !submitted.current) return <Navigate to={safeNext(params.get('next'))} replace />;

  return (
    <div style={s.page}>
      <form onSubmit={submit} style={s.card}>
        <h1 style={s.title}>Join RunFlow</h1>
        <p style={s.sub}>RunFlow is invite-only for now.</p>
        <label style={s.label}>Invite code
          <input style={s.input} value={invite} onChange={(e) => setInvite(e.target.value)} required />
        </label>
        <label style={s.label}>Email
          <input style={s.input} type="email" autoComplete="email" value={email}
                 onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label style={s.label}>Password (at least 10 characters)
          <input style={s.input} type="password" autoComplete="new-password" minLength={10}
                 value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <div role="alert" style={s.error}>{error}</div>}
        <button style={s.button} type="submit" disabled={busy}>
          {busy ? 'Creating…' : 'Create account'}
        </button>
        <p style={s.foot}>Already have one? <Link to="/login" style={s.link}>Sign in</Link></p>
      </form>
    </div>
  );
}
